import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ListSelectionDialogComponent } from "./listselection-dialog.component";
import { ListSelectionDialogOptions } from "./listselection-dialog";


@Injectable()
export class ListSelectionDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open List Selection Dialog Service Call

    Open(options?: ListSelectionDialogOptions): Observable<any> {
        const self = this;

        const openHandle = self.matDialog.open<ListSelectionDialogComponent>(ListSelectionDialogComponent, {
            disableClose: true,
            data: {
                ...options,
            },
            panelClass: 'listSelectionDialog',
            maxWidth: '80vw',
            maxHeight: '85vh',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}